module.exports = __webpack_public_path__ + "img/05—Applications—Central Storage.a232c14c.jpg";